import React from "react";
import { Button } from "convertupleads-theme";
import PreviewAndEditor from "../../../../../common/PreviewAndEditor";

const OutlinedButtonLarge = () => {
  return (
    <>
      <PreviewAndEditor
        height={"100px"}
        language="js"
        title={"Outlined Large button"}
        value={"<Button variant={\"outlined\"} size={'large'}>Large</Button>"}
      >
        <Button variant={"outlined"} size={"large"}>
          Large
        </Button>
      </PreviewAndEditor>
    </>
  );
};

export default OutlinedButtonLarge;
